export default {
    owner: 'Vlasnik usluge',

    tabs: {
        details: 'Detalji',
        availability: 'Dostupnost',
    },
}
